import React from "react";
import { Link, useHistory } from "react-router-dom";
import { Breadcrumb, Row, Col, Typography, Space, Button } from "antd";
import successPng from "../../../assets/images/success.png";

import { Colors } from "../../../theme";

const { Title } = Typography;
export default function EditProductSuccess() {
  const history = useHistory();
  return (
    <div>
      <Row>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/"> Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/master-catalogue"> All Products</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Edit Products</Breadcrumb.Item>
        </Breadcrumb>
      </Row>

      <Row justify="center" style={{ marginTop: "20px" }}>
        <Col>
         <Row justify="center">
         <img src={successPng} alt="success" width="386px" height="284px" />
           </Row>
          <Row justify="center" style={{ marginTop: "48px" }}>
            <Title level={2} style={{ fontFamily: "Avenir" }}>
              Product details updated successfully!
            </Title>
          </Row>
          <Row justify="space-around" style={{ marginTop: "40px" }}>
            <Space>
              <Button
                size="large"
                style={{
                  width: "100%",
                  color: Colors.white,
                  backgroundColor: Colors.black,
                }}
                onClick={() => history.push("/master-catalogue")}
              >
                View All Products
              </Button>
            </Space>
          </Row>
        </Col>
      </Row>
    </div>
  );
}
